//export const BASE_URL=process.env.NODE_ENV='development'?'':'',
// export const BASE_URL = "";
// export const BASE_URL = "https://footorder-qa-server.onrender.com";
export const BASE_URL = "https://zutle-live.onrender.com";
export const FOOD_ITEM_URL = "/api/foodItems";
export const CUSTOMERS_URL = "/api/customer";
export const OUTLET_URL = "/api/outlet";
export const ORDERS_URL = "/api/orders";
export const COMPANY_URL = "/api/company";
export const ADMIN_URL = "/api/admins";
export const TABLE_URL = "/api/outletTables";
export const EXPENSES_URL = "/api/expenses";
export const PAYMENTS_URL = "/api/payments";

// export const Shop_Domain = "https://qashop.zutle.in";
// The printer service always runs on the same machine as the browser, so it
// is reached through the loopback address, which stays the same whatever IP
// the network assigns to the machine
export const PRINTER_SERVICE_HOST = "127.0.0.1";

// export const Shop_Domain = "http://192.168.1.15:3001";
// export const Shop_Domain = "https://qashop.zutle.in";
export const Shop_Domain = "https://shop.zutle.in";
